export default __webpack_public_path__ + "static/media/icon-dropdown.3faa6dd5.svg";